// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"408":"7fa1b2f5","932":"a0b32cc3"}[chunkId] + ".js";
};